import { createDiv, createImage, createPara, createSVG, createTextField } from "../utils/utils";
import loadDashboardPage from "./Dashboard";
import SignInPageImg from "../assets/images/sign-in.png";
import SignUpPageImg from "../assets/images/sign-up.png";
import { auth } from "../firebase"; 
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup,onAuthStateChanged} from "firebase/auth";


export default function authPage(){
    const root = document.querySelector(".container");
    onAuthStateChanged(auth, (user) => {
        if (user) {
          renderDashboard();
        } else {
          renderAuth(root);
        }
      });
}

function SignInPage(getAuthContainer){

    const getSignInPageContainer = createDiv(getAuthContainer,"sign-in-container");
    // Left Seciton of the SignIn Page
    const getSignInPageLeft = createDiv(getSignInPageContainer,"signInPageLeft");
    createPara(getSignInPageLeft,"signIn-page-left-title","Taskly");
    const getSignInPageLeftImageContainer = createDiv(getSignInPageLeft,"signIn-page-left-image-container");
    createImage(getSignInPageLeftImageContainer,SignInPageImg,"signIn-page-img");

    // Right Seciton of the SignIn Page
    const getSignInPageRight = createDiv(getSignInPageContainer,"signInPageRight");

    const getSignInPageRightMain = createDiv(getSignInPageRight,"signIn-page-right-main");
    createPara(getSignInPageRightMain,"signIn-page-right-title","Sign In");
    createTextField(getSignInPageRightMain,"signIn-email","Enter your mail","email");
    createTextField(getSignInPageRightMain,"signIn-pass","Enter your password","password");

    const getSignInButton = createDiv(getSignInPageRightMain,"signIn-button");
    createPara(getSignInButton,"signIn-text","Sign In");
    
    getSignInButton.addEventListener("click", handleSignIn);
    document.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
            handleSignIn();
        }
    });

    const getSignInDivider = createDiv(getSignInPageRightMain,"signIn-divider");
    createDiv(getSignInDivider,"signIn-h-line");
    createPara(getSignInDivider,"signIn-divider-text","or");
    createDiv(getSignInDivider,"signIn-h-line");

    const getGoogleSignInButton = createDiv(getSignInPageRightMain,"google-signIn-button");
    createSVG(getGoogleSignInButton,"google-svg","M21.35,11.1H12.18V13.83H18.69C18.36,17.64 15.19,19.27 12.19,19.27C8.36,19.27 5,16.25 5,12C5,7.9 8.2,4.73 12.2,4.73C15.29,4.73 17.1,6.7 17.1,6.7L19,4.72C19,4.72 16.56,2 12.1,2C6.42,2 2.03,6.8 2.03,12C2.03,17.05 6.16,22 12.25,22C17.6,22 21.5,18.33 21.5,12.91C21.5,11.76 21.35,11.1 21.35,11.1V11.1Z");
    createPara(getGoogleSignInButton,"google-signIn-text","Sign In with Google");

    getGoogleSignInButton.addEventListener("click", signInWithGoogle);

    const getNoAccountDiv = createDiv(getSignInPageRightMain,"no-account");
    createPara(getNoAccountDiv,"no-account-text","Don't have an account? Sign up");

    getNoAccountDiv.addEventListener("click", () => {
        switchPage(getAuthContainer, SignUpPage);
    });
}

function SignUpPage(authContainer){

    const getSignUpPageContainer = createDiv(authContainer,"sign-up-container");
    // Left Seciton of the SignUp Page
    const getSignUpPageLeft = createDiv(getSignUpPageContainer,"signUpPageLeft");
    createPara(getSignUpPageLeft,"signUp-page-left-title","Taskly");
    const getSignUpPageLeftImageContainer = createDiv(getSignUpPageLeft,"signUp-page-left-image-container");
    const getSignUpImg = createImage(getSignUpPageLeftImageContainer,SignUpPageImg,"signUp-page-img");
    // Right Seciton of the SignUp Page
    const getSignUpPageRight = createDiv(getSignUpPageContainer,"signUpPageRight");

    const getSignUpPageRightMain = createDiv(getSignUpPageRight,"signUp-page-right-main");
    createPara(getSignUpPageRightMain,"signUp-page-right-title","Sign Up");
    createTextField(getSignUpPageRightMain,"signUp-name","Enter your username","text");
    createTextField(getSignUpPageRightMain,"signUp-email","Enter your mail","email");
    createTextField(getSignUpPageRightMain,"signUp-pass","Enter your password","password");

    const getSignUpButton = createDiv(getSignUpPageRightMain,"signUp-button");
    createPara(getSignUpButton,"signUp-text","Sign Up");

    getSignUpButton.addEventListener("click",handleSignUp)

    const getSignUpDivider = createDiv(getSignUpPageRightMain,"signUp-divider");
    createDiv(getSignUpDivider,"signUp-h-line");
    createPara(getSignUpDivider,"signUp-divider-text","or");
    createDiv(getSignUpDivider,"signUp-h-line");

    const getGoogleSignUpButton = createDiv(getSignUpPageRightMain,"google-signUp-button");
    createSVG(getGoogleSignUpButton,"google-svg","M21.35,11.1H12.18V13.83H18.69C18.36,17.64 15.19,19.27 12.19,19.27C8.36,19.27 5,16.25 5,12C5,7.9 8.2,4.73 12.2,4.73C15.29,4.73 17.1,6.7 17.1,6.7L19,4.72C19,4.72 16.56,2 12.1,2C6.42,2 2.03,6.8 2.03,12C2.03,17.05 6.16,22 12.25,22C17.6,22 21.5,18.33 21.5,12.91C21.5,11.76 21.35,11.1 21.35,11.1V11.1Z");
    createPara(getGoogleSignUpButton,"google-signUp-text","Sign In with Google");

    getGoogleSignUpButton.addEventListener("click", signInWithGoogle);

    const getNoAccountDiv = createDiv(getSignUpPageRightMain,"no-account");
    createPara(getNoAccountDiv,"no-account-text","Already have an account? Sign In");
    getNoAccountDiv.addEventListener("click", () => {
        switchPage(authContainer, SignInPage);
    });
}

async function handleSignIn() {
    const email = document.querySelector("#signIn-email").value;
    const password = document.querySelector("#signIn-pass").value;

    try {
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        console.log("User logged in:", userCredential.user);
        loadDashboardPage();
    } catch (error) {
        console.error("Error logging in:", error.message);
        alert(error.message);
    }
}
async function handleSignUp() {
    const email = document.querySelector("#signUp-email").value;
    const password = document.querySelector("#signUp-pass").value;
    const username = document.querySelector("#signUp-name").value;
    
    try {
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        console.log("User signed up:", userCredential.user);
        loadDashboardPage();
    } catch (error) {
        console.error("Error signing up:", error.message);
        alert(error.message);
    }
}
async function signInWithGoogle() {
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);

      // This gives you a Google Access Token.
      const credential = GoogleAuthProvider.credentialFromResult(result);
      const token = credential.accessToken;
  
      // The signed-in user info
      const user = result.user;
  
      console.log("Google Sign-In Success:", user);
      loadDashboardPage();
  
    } catch (error) {
      console.error("Google Sign-In Error:", error.message);
      alert(error.message);
    }
}
function switchPage(container, authPage) {
    container.classList.add("hide");
  
    setTimeout(() => {
      container.innerHTML = "";
      authPage(container);
      container.classList.remove("hide");
    }, 500);
}

function renderAuth(root) {
    root.innerHTML = "";
    SignInPage(root);
}
  
function renderDashboard() {
    loadDashboardPage();
}
